import {
  ModuleCategory,
  SchemaInstructionsHelper,
  SchemaTypeHelper,
  SingleUnion,
  SubscribesTo,
  createComponentAdmin,
} from '@backstage-components/base';
import {Static, Type} from '@sinclair/typebox';

export const reactName = 'QRCode';
export const name = 'QR Code';
export const description = reactName;
const category: ModuleCategory = 'media';

const schema = Type.Object({
  size: Type.Number({title: 'Size'}),
  value: Type.String({title: 'URL'}),
});

const defaultFieldData: Static<typeof schema> = {
  size: 75,
  value: 'default-url',
};

const instructions = SingleUnion(
  SubscribesTo({
    topic: `${reactName}:setUrl`,
    description:
      'Updates the url value that will be "retrieved" by scanning the QR code',
    meta: {
      url: Type.String({
        title: 'URL',
        description: 'The new value of the QR code to set.',
      }),
    },
  })
);

export const ComponentDefinition = createComponentAdmin({
  id: '763f9955-5527-4955-a2bb-bd1e0e1f514c',
  reactName,
  name,
  slug: reactName,
  description,
  version: 1,
  defaultFieldData,
  slotConfiguration: {},
  schema,
  uiSchema: {},
  instructions,
  category,
})
  .withAnimationStates()
  .withStyles()
  .build();

export type InstructionSchemaType = SchemaInstructionsHelper<
  typeof ComponentDefinition
>;

export type SchemaType = SchemaTypeHelper<typeof ComponentDefinition>;
